<div class="metric-widget">
  <div class="metric-header">
    <div class="metric-icon-container">
      <bringoz-icon [iconName]="iconName" [fill]="iconColor" class="metric-icon"></bringoz-icon>
    </div>
    <span class="metric-title">{{ title | translate }}</span>
    <ng-content></ng-content>
  </div>
  <span class="metric-value">
    <ng-container *ngIf="isValueString">{{ value || 0 }}</ng-container>
    <ng-container *ngIf="!isValueString">{{ value || 0 | number }}</ng-container>
  </span>
</div>

